import React from "react";
import { Outlet } from "react-router-dom";
import StepperBar from "@/features/travel-journey-layout/components/stepper-bar";

export default function TravelJourneyStepsLayout() {
  return (
    <div
      className="bg-white"
      data-testid="travel-journey-container"
    >
      <StepperBar />
      <div data-testid="travel-journey-steps-container">
        <Outlet />
      </div>
    </div>
  );
}
